import type { LocationResponseType } from './types';

export class Location {
    private _location: LocationResponseType | null;
    private _innerId: string;
    private manualCoords: boolean = false;

    constructor() {
        this._innerId = Math.random().toString(36).substring(7);
        this._location = null;
    }

    public getId(): number | null {
        return this._location?.id || null;
    }

    public getExtId(): string | null {
        return this._location?.ext_id || null;
    }

    public getFullName(): string | null {
        return this._location?.full_name || null;
    }

    public getLocationType(): string | null {
        return this._location?.location_type || null;
    }

    public getCity(): string {
        return this._location?.address_attributes?.city || '';
    }

    public getPostalCode(): string {
        return this._location?.address_attributes?.pcode || '';
    }

    public getStreet(): string {
        return this._location?.address_attributes?.street || '';
    }

    public getHouse(): string {
        return this._location?.address_attributes?.house || '';
    }

    public getFullStreet(): string {
        return this.getStreet() + ' ' + this.getHouse();
    }

    public editable() {
        if (this._location === null) {
            return false;
        }
        return true;
    }

    public set(jobResponse: LocationResponseType): this {
        this._location = jobResponse;
        return this;
    }

    public get innerId(): string {
        return this._innerId;
    }

    public isManuallySetCoords(): boolean {
        return this.manualCoords;
    }

    public setCoords(x: number, y: number, manually: boolean = false): void {
        if (this._location) {
            if (!this._location.geom) {
                this._location.geom = {
                    type: 'Point',
                    coordinates: [0, 0],
                };
            }
            this._location.geom.coordinates = [x, y];
            this._location.coords_accepted = true;
            if (manually) {
                this.manualCoords = true;
            }
        }
    }

    public get id(): number | null {
        return this._location?.id || null;
    }

    public getData(): LocationResponseType | null {
        return this._location;
    }

    public getTargetDate(): string | null {
        return null;
    }

    public updateAddressAttributeValue(
        key: string,
        value: any,
        copyAllToClient: boolean = true
    ): void {
        if (this._location) {
            if (this._location.address_attributes === null) {
                this._location.address_attributes = {
                    [key]: value,
                };
            } else {
                this._location.address_attributes[key] = value;
            }
        }
        if (copyAllToClient) {
            this.copyAddressAttributesToClientAttributes();
        }
    }

    public copyAddressAttributesToClientAttributes(): void {
        // const iso8859_1Bytes = new Uint8Array([101, 120, 97, 109, 112, 108, 101, 243, 115, 116, 114, 105, 110, 103]);

        if (this._location && this._location.address_attributes !== null) {
        }
    }

    public getX() {
        return this._location?.geom?.coordinates[0] || null;
    }

    public getY() {
        return this._location?.geom?.coordinates[1] || null;
    }

    public hasCoords(): boolean {
        return this._location?.geom !== null && this.getX() !== null && this.getY() !== null;
    }
}
